import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import api, { apiError } from "@/lib/api";

const XeroCallback = () => {
  const navigate = useNavigate();
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    const params = new URLSearchParams(window.location.search);
    const code = params.get("code");
    const state = params.get("state");
    const error = params.get("error");
    if (error || !code || !state) {
      toast.error("Xero connection was cancelled");
      navigate("/app/settings", { replace: true });
      return;
    }
    api.post("/integrations/xero/callback", { code, state })
      .then(({ data }) => { toast.success(`Connected to ${data.organisation || "Xero"}`); })
      .catch((err) => { toast.error(apiError(err.response?.data?.detail) || "Xero connection failed"); })
      .finally(() => navigate("/app/settings", { replace: true }));
  }, [navigate]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center gap-3 text-slate-500" data-testid="xero-callback">
      <Loader2 className="h-8 w-8 animate-spin text-[#13B5EA]" />
      <p>Connecting your Xero organisation…</p>
    </div>
  );
};

export default XeroCallback;
